import { render } from "./EditDataPage.vue?vue&type=template&id=637d992d&scoped=true&ts=true"
import script from "./EditDataPage.vue?vue&type=script&lang=ts"
export * from "./EditDataPage.vue?vue&type=script&lang=ts"

import "./EditDataPage.vue?vue&type=style&index=0&id=637d992d&scoped=true&lang=css"

import exportComponent from "F:\\Programming_And_Stuff\\Programming\\Stella-Maris-53-VueJSOld\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637d992d"]])

export default __exports__